import {MapSchema} from "@colyseus/schema";
import {KitchenScene} from "./scene";
import {GameSpriteGroup, IGameSprite} from "./game_sprite_base";
import {mainLogger} from "./client_logger";


const logger = mainLogger.child({label: 'client.synchronizer'})


export function syncSpritesOnObjects(schemaObjectGroup: MapSchema<any>, gameSpriteGroup: GameSpriteGroup<any, Phaser.GameObjects.GameObject & IGameSprite<any>>) {
    schemaObjectGroup.onAdd( (instance, key) => {
        logger.info(`${gameSpriteGroup.spriteModel.name} added: [${key}]=${instance.id}`)
        let sprite = gameSpriteGroup.findOrCreate(instance)
        bindGameSprite(sprite);
        (<KitchenScene>gameSpriteGroup.scene).onObjectAdded(sprite)
    })
    schemaObjectGroup.onRemove( async (instance, id) => {
        logger.debug(`received remove ingredient ${instance.id}`)
        let sprite = gameSpriteGroup.find(instance)
        if (sprite) {
            await gameSpriteGroup.remove(sprite, true, true);
            (<KitchenScene>gameSpriteGroup.scene).onObjectRemove(sprite)
        }
    })
}

function bindGameSprite(sprite: IGameSprite<any>) {
    sprite.bindToInstance()
}

